import useJob from "@/hooks/useJob";
import stripTags from "@sourceflow-uk/functions/stripTags";
import { JobPostingJsonLd } from "next-seo";
import { useMemo } from "react";

const NEXT_PUBLIC_SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME;
const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
const NEXT_PUBLIC_LOGO = process.env.NEXT_PUBLIC_LOGO;

export default function ({ url_slug }) {
  const job = useJob(url_slug);

  const employmentType = useMemo(() => {
    return [...new Set(job.employment_types.map((e) => e.schema_job_type))];
  }, [job]);

  const unitText = useMemo(() => {
    if (job?.salary_package?.toLowerCase().includes("year")) {
      return "YEAR";
    }
    if (job?.salary_package?.toLowerCase().includes("month")) {
      return "MONTH";
    }
    if (job?.salary_package?.toLowerCase().includes("hour")) {
      return "HOUR";
    }

    return "YEAR";
  }, [job?.salary_package]);

  const value = useMemo(() => {
    if (!job?.salary_package) {
      return null;
    }

    return job?.salary_package
      .split(/[\s-]+/)
      .map((s) => {
        const v = s.replace(/^\D+/g, "");
        return v.endsWith("k") ? parseInt(v) * 1000 : parseInt(v);
      })
      .filter((n) => !!n);
  }, [job?.salary_package]);

  const currency = useMemo(() => {
    return (job?.salary_package?.match(
      /[$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/,
    ) ?? ["£"])[0];
  }, [job?.salary_package]);

  return (
    <JobPostingJsonLd
      useAppDir={false}
      title={job?.title}
      description={stripTags(job?.description)}
      datePosted={job?.published_at}
      baseSalary={{
        value,
        currency,
        unitText,
      }}
      hiringOrganization={{
        name: NEXT_PUBLIC_SITE_NAME,
        sameAs: NEXT_PUBLIC_BASE_URL,
        logo: NEXT_PUBLIC_LOGO,
      }}
      jobLocation={{
        addressRegion: job?.location ?? job?.addresses[0] ?? "",
        addressCountry: "",
      }}
      validThrough={job?.expires_at}
      employmentType={employmentType}
    />
  );
}
